import { AmountObject } from '~/services/pay';

export const retryCount = 5;

export const amountArr: AmountObject[] = [
  { key: 'CUSTOM', value: 200 },
  { key: 'PLUGIN_20', value: 20 },
  { key: 'PLUGIN_50', value: 50 },
  { key: 'PLUGIN_100', value: 100 },
  { key: 'PLUGIN_200', value: 200 },
  { key: 'PLUGIN_500', value: 500 },
  { key: 'PLUGIN_1000', value: 1000 },
];
